<template>
  <v-app>
    <router-view name="sidebar" />
    <router-view name="header" :handleSettingsDrawer="handleSettingsDrawer" />
    <v-main class="vuse-content">
        <router-view @launch-snackbar="launchSnackbar"/>
    </v-main>
    <router-view name="footer" />
    <app-settings-drawer
      :handleDrawer="handleSettingsDrawer"
      :drawer="settingsDrawer"
    />
    <confirm-dialog
      ref="confirmDialog"
      :title="dialogTitle"
      :message="dialogMessage"
    />
    <v-snackbar
      v-model="snackbar"
      absolute
      right
      :timeout="snackbarTimeout"
      :color="snackbarColor"
      class="mb-8"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>

    <custom-loader />

  </v-app>
</template>

<script>
import AppSettingsDrawer from "@/layouts/App/AppSettingsDrawer";
import ConfirmDialog from "@/components/UI/Dialogs/ConfirmDialog";
import CustomLoader from "@/components/UI/Loader/CustomLoader";
import {mapActions, mapGetters} from "vuex";
import AuthApi from "@/mixins/Services/AuthApi";
import logoutSession from "@/mixins/Logout";
import snackBar from "@/mixins/snackBarMixin";

export default {

  components: {
    AppSettingsDrawer,
    ConfirmDialog,
    CustomLoader
  },

  mixins: [AuthApi, logoutSession, snackBar],

  data: () => {
    return {
      settingsDrawer: false,
      dialogTitle: "",
      dialogMessage: null,
      kiosk: false
    };
  },
  computed: {
    ...mapGetters(['showNotification','notification','getSessionTime', "getDataLogin"])
  },
  methods: {
    ...mapActions(["setShowNotification", "setLogout", "deleteDefsData"]),
    handleSettingsDrawer() {
      this.settingsDrawer = !this.settingsDrawer;
    }
  },

  mounted() {
    setInterval(async() => {
      if ( this.getSessionTime > 0 && this.getSessionTime < Date.now()) {
          this.logoutSession()
            .then (()=> this.launchSnackbar(this.$t("Global.Session.expirationMessage"), "error", "3000", "mdi-alert-octagon"))
      }
    }, 1000)
  }
};
</script>
